import { render } from "./SliderLamar.vue?vue&type=template&id=20f25ed8"
import script from "./SliderLamar.vue?vue&type=script&lang=js"
export * from "./SliderLamar.vue?vue&type=script&lang=js"

import "./SliderLamar.vue?vue&type=style&index=0&id=20f25ed8&lang=css"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__